import { forwardRef, type Ref, type SVGProps } from "react";
const IconPauseOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M12 25h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2M10 9v14h2V9zm12 16h-2a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2M20 9v14h2V9z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPauseOutlineSVG);
ForwardRef.displayName = "IconPauseOutline";
export { ForwardRef as IconPauseOutline };
